// extracted by mini-css-extract-plugin
export default {"starRating":"StarRating__starRating","stars":"StarRating__stars","starsEmpty":"StarRating__starsEmpty","starsFilled":"StarRating__starsFilled"};